import React from 'react'
import PropTypes from 'prop-types'
import { SidebarCTABox, SidebarCTABoxHeader, SidebarCTABoxLink, SidebarCTABoxBody } from './SidebarCTABox'
import { editSupplierOnboarding } from '../routes/path'

const UnclaimedCTABox = ({ className, supplierId }) => {
  return (
    <SidebarCTABox className={className}>
      <SidebarCTABoxHeader>
        Is this your business?
      </SidebarCTABoxHeader>
      <SidebarCTABoxBody>This business profile is currently unmanaged. Keeping this profile up to date helps government buyers find your profile and make informed decisions when preparing to spend.</SidebarCTABoxBody>
      <SidebarCTABoxLink
        text='Manage your free business page'
        href={editSupplierOnboarding(supplierId)}
      />
    </SidebarCTABox>
  )
}

UnclaimedCTABox.propTypes = {
  className: PropTypes.string,
  supplierId: PropTypes.number.isRequired
}

export default UnclaimedCTABox
